import { render, staticRenderFns } from "./GroupsStats.vue?vue&type=template&id=22586ba0&scoped=true"
import script from "./GroupsStats.vue?vue&type=script&lang=js"
export * from "./GroupsStats.vue?vue&type=script&lang=js"
import style0 from "./GroupsStats.vue?vue&type=style&index=0&id=22586ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22586ba0",
  null
  
)

export default component.exports